import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDossiersController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDossiersController.php
* @route '/api/company/{company}/elys/dossier'
*/
const ElysGetDossiersController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetDossiersController.url(args, options),
    method: 'get',
})

ElysGetDossiersController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/dossier',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDossiersController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDossiersController.php
* @route '/api/company/{company}/elys/dossier'
*/
ElysGetDossiersController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return ElysGetDossiersController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDossiersController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDossiersController.php
* @route '/api/company/{company}/elys/dossier'
*/
ElysGetDossiersController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetDossiersController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDossiersController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDossiersController.php
* @route '/api/company/{company}/elys/dossier'
*/
ElysGetDossiersController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysGetDossiersController.url(args, options),
    method: 'head',
})

export default ElysGetDossiersController